/* merchant/reducer */
import { createReducer } from "typesafe-actions";
import { AuditActionTypes, AuditState } from "./types";
import { fetchRequest, fetchSuccess, fetchError } from "./actions";

export const initialState: AuditState = {
  data: undefined,
  errors: undefined,
  loading: false
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>;

export default createReducer<AuditState, ActionType>(initialState)
  .handleType(AuditActionTypes.FETCH, state => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(AuditActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined
    };
  })
  .handleType(AuditActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: { data: [], errors: null, pagination: null },
      errors: action.payload
    };
  });
